module.exports = __webpack_public_path__ + "static/media/weare.502cec61.png";